import { Modal, Tip } from '@vzmi/shp_shared_compo'
import { TABLE_TYPE } from '../../helper'
import styles from './index.css'

const ImportRuleModal = props => {
  const {
    visible,
    setVisible,
    tableType
  } = props

  const onCancel = () => setVisible(false)

  return (
    <Modal
      visible={visible}
      data-role={`${tableType}ImportRuleModal`}
      onOk={onCancel}
      onCancel={onCancel}
      width={445}
      className={styles.modal}
      okText='我知道了'
      cancelButtonVisible={false}
      destroyOnClose
    >
      <br />
      匯入的商品，需符合以下條件：
      <br />
      • 供應商、倉別、配送方式需與賣場相同
      <br />
      {(tableType !== TABLE_TYPE.ADDITIONAL_PURCHASES) && (
        <Tip
          type='important'
          className={styles.tip}
        >
          • 成本需為0
        </Tip>
      )}
      • 若為快倉商品，必須已入倉(有備貨數量)
    </Modal>
  )
}

export default ImportRuleModal
